/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ProductApiConfiguration, ProductApiConfigurationInterface } from './product-api-configuration';

import { ApiService } from './services/api.service';

/**
 * Provider for all ProductApi services, plus ProductApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ProductApiConfiguration,
    ApiService
  ],
})
export class ProductApiModule {
  static forRoot(customParams: ProductApiConfigurationInterface): ModuleWithProviders<ProductApiModule> {
    return {
      ngModule: ProductApiModule,
      providers: [
        {
          provide: ProductApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
